import { Navigate } from "react-router-dom";
import { useUser } from "./user_context";
import "./global-styles-portal";
import { canOpenSection, firstAdminPath } from "./portal/admin/admin_nav";

// `section` is the admin panel area this route belongs to; managers only get
// the sections a super admin delegated to them.
export default function AdminRoute({ children, section }) {
  const { userData, loading } = useUser();

  if (loading) return null;

  if (!userData) {
    return <Navigate to="/signin" replace />;
  }

  if (!userData.isAdmin) {
    return userData.role === "employer"
      ? <Navigate to="/employer/dashboard" replace />
      : <Navigate to="/dashboard" replace />;
  }

  if (section && !canOpenSection(userData, section)) {
    const fallback = firstAdminPath(userData);
    return fallback
      ? <Navigate to={fallback} replace />
      : <Navigate to={userData.role === "employer" ? "/employer/dashboard" : "/dashboard"} replace />;
  }

  return children;
}
